/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/enableTwoFactor.scss';

import {ChangeFunction, CloseButton, Loader, NumberString, WithBackground} from '@dvrd/dvr-controls';

import React, {KeyboardEventHandler, MouseEventHandler} from 'react';

import {BluemateNumberInput} from '../../controls';

interface Props {
    onChange: ChangeFunction<NumberString>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onClose: MouseEventHandler;
    qrCode: string;
    token: string;
    active: boolean;
    loading: boolean;
}

export default function EnableTwoFactor(props: Props) {
    const {qrCode, onSubmit, token, onChange, loading, onClose, active} = props;

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='enable-two-factor'>
                <div className='header-container'>
                    <label className='header-title'>Tweestapsverificatie activeren</label>
                    <CloseButton onClick={onClose} />
                </div>
                <div className='body-container'>
                    <Loader active={loading} />
                    <p>
                        {!qrCode.length
                            ? 'QR code genereren...'
                            : 'Download een authenticator app (zoals Google Authenticator of Authy) uit de app store van ' +
                              'je smartphone en scan onderstaande QR code met de app. Vul daarna de gegenereerde code ' +
                              'in om tweestapsverificatie te activeren.'}
                    </p>
                    <div className='qr'>
                        {qrCode.length > 0 ? (
                            <img src={qrCode} alt='QR code genereren mislukt' width={100} height={100} />
                        ) : (
                            <Loader active />
                        )}
                    </div>
                    <BluemateNumberInput
                        onChange={onChange}
                        value={token}
                        label='Code'
                        onEnter={onSubmit}
                        autoFocus
                        wholeNumbers
                    />
                </div>
            </div>
        </WithBackground>
    );
}
